import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ASSETS } from "@/lib/site";
import Reveal from "./Reveal";

const stats = [
  ["3000+", "Installations across Perth"],
  ["100%", "Licensed & insured team"],
  ["#1", "Australian Installer"],
];

export default function WhoWeAre() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const bgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      ref={ref}
      id="about"
      data-testid="about-section"
      className="relative overflow-hidden pt-16 pb-14 lg:pt-24 lg:pb-20"
    >
      <motion.div
        style={{ y: bgY }}
        className="absolute inset-0 -z-10 bg-cover bg-center scale-125"
      >
        <img
          src={ASSETS.home}
          alt="Premium modern home protected by LEAK SMART SHIELD"
          className="h-full w-full object-cover opacity-40"
        />
      </motion.div>
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-[#050505] via-[#050505]/85 to-[#050505]" />

      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid lg:grid-cols-[1fr_1.5fr] gap-12 lg:gap-16 items-end">
          <div className="max-w-3xl">
            <Reveal>
              <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#169ED9]">
                / Who we are
              </span>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-6 font-heading font-extrabold tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
                Perth&apos;s Trusted Installer Of Smart Valve Technology.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 text-white/60 leading-relaxed max-w-2xl">
                As Australia&apos;s leading installers of this innovative technology,{" "}
                <a
                  href="https://www.tpeco.com.au"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="about-tpeco-link"
                  className="text-white font-medium underline decoration-[#169ED9]/50 underline-offset-4 hover:text-[#169ED9] hover:decoration-[#169ED9] transition-colors duration-300"
                >
                  The Plumbing &amp; Electrical Co.
                </a>{" "}
                has completed more than 3000 successful installations across Perth. Our team is
                fully licensed, insured, and manufacturer-trained — giving you complete
                confidence your install is completed correctly, safely, and to the
                highest standard.
              </p>
            </Reveal>
            <Reveal delay={0.13}>
              <p className="mt-6 text-white/60 leading-relaxed max-w-2xl">
                As a <span className="text-[#169ED9]">Caroma trained installer</span>, and
                with GWA Water Solutions&apos; support, we&apos;ve made it simple to purchase the Leak
                SmartShield valve with installation included — one easy, fully-inclusive package.
              </p>
            </Reveal>
          </div>

          <Reveal delay={0.15}>
            <div className="relative lg:scale-[1.25] lg:origin-bottom">
              <div className="pointer-events-none absolute inset-0 bg-[#00E5FF]/10 blur-[80px] rounded-full" />
              <img
                src={ASSETS.team}
                alt="The Plumbing & Electrical Co. team"
                data-testid="about-team-image"
                className="relative w-full h-auto object-contain drop-shadow-2xl"
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>

        <div className="mt-20 grid grid-cols-1 sm:grid-cols-3 gap-8 lg:gap-4">
          {stats.map(([n, l], i) => (
            <Reveal key={l} delay={i * 0.08}>
              <div className="border-t border-white/15 pt-6">
                <div className="font-heading font-black tracking-tighter text-5xl lg:text-7xl text-white">
                  {n}
                </div>
                <div className="mt-3 font-mono text-[11px] uppercase tracking-[0.15em] text-white/50">
                  {l}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
